import React from "react"
import { Row, Col } from "react-bootstrap"
import BootstrapToggle from "react-bootstrap-toggle"
import PropTypes from "prop-types"
import classNames from "classnames"

require("react-bootstrap-toggle/dist/bootstrap2-toggle.css")
require("app/static/stylus/ExplainedToggle.styl")

/**
 * Render a react bootstrap toggle component
 * Can accept an object of classes to apply in addition to "explained-toggle"
 *
 */
export const ExplainedToggle = ({
    additionalClasses,
    onExplanation,
    onExplanationHeader,
    offExplanation,
    offExplanationHeader,
    active,
    dataCy,
    onChange,
    ...props
}) => {
    const classes = classNames({ ...additionalClasses, "explained-toggle": true })
    return (
        <Row className={classes}>
            <Col className="explained-toggle-col" data-cy={dataCy || "explained-toggle"} md={4}>
                <BootstrapToggle {...props} onClick={onChange} active={active} />
            </Col>
            <Col className="explained-toggle-explanation" data-cy="explained-toggle-explanation" md={8}>
                {(onExplanationHeader || offExplanationHeader) && (
                    <div className="explained-toggle-explanation-header">
                        {active ? onExplanationHeader : offExplanationHeader}
                    </div>
                )}
                {active ? onExplanation : offExplanation}
            </Col>
        </Row>
    )
}

export default ExplainedToggle

ExplainedToggle.propTypes = {
    // provided by parent
    active: PropTypes.bool,
    additionalClasses: PropTypes.object,
    height: PropTypes.number,
    off: PropTypes.string,
    offExplanation: PropTypes.string,
    offExplanationHeader: PropTypes.string,
    on: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onExplanation: PropTypes.string,
    onExplanationHeader: PropTypes.string,
    size: PropTypes.string,
    width: PropTypes.number,
    dataCy: PropTypes.string,
    disabled: PropTypes.bool,
}

ExplainedToggle.defaultProps = {
    active: false,
    additionalClasses: {},
    off: "Off",
    offExplanationHeader: "",
    offExplanation: "Off Explanation...",
    on: "On",
    onExplanationHeader: "",
    onExplanation: "On Explanation...",
    size: "lg",
    // required because the componentDidUpdate lifecycle method in react-bootstrap-toggle calls
    //      this.setDimensions() (if width/height are not defined) which calls this.setState({ which
    //      triggers an infinite loop ('Invariant Violation: Maximum update depth exceeded.') when tested
    // the author refuses to fix this anti-pattern, so this is necessary
    // https://github.com/arnthor3/react-bootstrap-toggle/issues/31
    width: undefined,
    height: undefined,
}
